export enum ExtraType {
  damageWaiver = 'damageWaiver',
  roadsideAssistance = 'roadSideAssistance',
}
